/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
// REMOVE: remove this, only for testing of step 8 and 9, to set dummy values for tariff activation form
// import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
// import { useActivation, useTariff } from '@context/MobileOne';
// REMOVE: remove this, only for testing of step 8 and 9, to set dummy values for tariff activation form
// import { usePayment } from '@context/Payment';
import {
  ButtonPrimary,
  ButtonCancelActivation,
  Chip,
  Link,
  NavigationPageTitle,
  ScrollToTop,
  Ta11yText,
  CardSupport
} from '@core/index';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { useA11y } from '@context/Utils';
import { replaceDynamicCmsContent } from '@utils/a11y/a11yHelpers';
import {
  appButtonType,
  appChipStyle,
  appIconsPath,
  appLinkStyle,
  appTariffs,
  parseToGermanPrice
} from '@utils/globalConstant';

export function MpsAutoTopupOverview() {
  // Contexts
  const { tA11yTranslate } = useA11y();
  const {
    setStep8SubStep,
    nextStep,
    setStep9SubStep,
    setWithAutoTopup,
    tariffActivationForm,
    getTariffName
  } = useActivation();
  // REMOVE: remove this, only for testing of step 8 and 9, to set dummy values for tariff activation form
  // const { setStep8SubStep, nextStep, setStep9SubStep, setWithAutoTopup, setSelectedTariffId, setTariffActivationForm, tariffActivationForm } = useActivation();
  // REMOVE: remove this, only for testing of step 8 and 9, to set dummy values for tariff activation form
  // const { setActivationMpsTopupPayment } = usePayment();

  // NavigationPageTitle expects CMS key string, not translated object
  let autoTopupPageHeadingKey = '';
  let autoTopupGreenBoxHeading = '';
  let autoTopupGreenBoxText = '';
  if (
    tariffActivationForm.chosenTariffId === appTariffs.TALK ||
    tariffActivationForm.chosenTariffId === 0
  ) {
    autoTopupPageHeadingKey = 'ek_reg_autotopup_hdl1';
    autoTopupGreenBoxHeading = tA11yTranslate('ek_reg_autotopup_hdl2');
    autoTopupGreenBoxText = tA11yTranslate('ek_reg_autotopup_txt1');
  } else {
    autoTopupPageHeadingKey = 'ek_reg_autotopup_hdl3';
    autoTopupGreenBoxHeading = getTariffName(
      tariffActivationForm.chosenTariffName,
      tariffActivationForm.chosenTariffSpeed,
      'ek_reg_autotopup_hdl4'
    );
    autoTopupGreenBoxText = replaceDynamicCmsContent(
      tA11yTranslate('ek_reg_autotopup_txt2'),
      '{TARIFFPRICE}',
      parseToGermanPrice(tariffActivationForm.tariffAmount)
    );
  }

  // REMOVE: remove this useEffect, only for testing of step 8 and 9, to set dummy values for tariff activation form
  // useEffect(() => {

  // // START LTE 1304
  // const dummyTariffActivationForm = {
  //   "chosenTariffId": 1304,
  //   "chosenTariffName": "ek_tariff_start_name",
  //   "chosenTariffSpeed": "",
  //   "tariffColor": "#12837F",
  //   "tariffPrice": "ek_tariff_start_price",
  //   "tariffAmount": 0.0,
  //   "tariffAmountAsStr": "0.0"
  // };

  // // Smart S 5G 1307
  // const dummyTariffActivationForm = {
  //   "chosenTariffId": 1307,
  //   "chosenTariffName": "ek_tariff_smart-s_name",
  //   "chosenTariffSpeed": "ek_tariff_5g_txt",
  //   "tariffColor": "#C23945",
  //   "tariffPrice": "ek_tariff_smart-s-5g_price",
  //   "tariffAmount": 8.99,
  //   "tariffAmountAsStr": "8.99"
  // };
  // // only needed for Smart S 5G
  // setActivationMpsTopupPayment((prev) => ({
  //   ...prev,
  //   amount: dummyTariffActivationForm.tariffAmount
  // }));

  //   // needed for both START tariff and all other tariffs
  //   setSelectedTariffId(dummyTariffActivationForm.chosenTariffId);
  //   setTariffActivationForm(dummyTariffActivationForm);
  // }, []);

  return (
    <ScrollToTop>
      <AppPageContentWrapper>
        <NavigationPageTitle title={autoTopupPageHeadingKey} variant="sm" />

        <div className="card mt-32 mb-48 p-16 rounded-2 bg-darkgreen text-white bg-ek-gradient">
          <div className="mb-20">
            <Chip
              chipStyle={appChipStyle.HIGHLIGHT}
              icon={appIconsPath.STAR}
              label="ek_global_recommended_chip"
            />
          </div>
          <Ta11yText
            tag="h2"
            className="ek-copy-20-semibold mb-20"
            textContent={autoTopupGreenBoxHeading}
          />
          <Ta11yText
            tag="p"
            className="ek-copy-16-regular mb-20"
            textContent={autoTopupGreenBoxText}
          />
          <div className="mb-20">
            <ButtonPrimary
              buttonType={appButtonType.SECONDARY}
              buttonContent={tA11yTranslate('ek_reg_autotopup_btn3')}
              onClick={() => {
                setWithAutoTopup(true);
                if (
                  tariffActivationForm.chosenTariffId === appTariffs.TALK ||
                  tariffActivationForm.chosenTariffId === 0
                ) {
                  // go to activation amount page for START tariff
                  setStep8SubStep(2);
                } else {
                  // go directly to activation payment method page for all other tariffs
                  setStep8SubStep(3);
                }
              }}
              customClass="justify-content-center"
            />
          </div>
          <Link linkStyle={`${appLinkStyle.SECONDARY}`} onClick={() => setStep8SubStep(1)}>
            <Ta11yText textContent={tA11yTranslate('ek_reg_autotopup_lnk1')} tag="span" />
          </Link>
        </div>

        <div className="row">
          <div className="col-11 col-sm-9 col-md-9 col-lg-6 mx-auto mb-48">
            <ButtonPrimary
              buttonType={appButtonType.WHITE}
              icon="forwardprimary"
              iconColorType="dark"
              buttonContent={tA11yTranslate('ek_reg_autotopup_btn2')}
              onClick={() => {
                setWithAutoTopup(false);
                setStep9SubStep(0);
                nextStep();
              }}
            />
          </div>
        </div>

        <div className="row mb-32">
          <CardSupport />
        </div>

        <div className="d-flex justify-content-center">
          <ButtonCancelActivation />
        </div>
      </AppPageContentWrapper>
    </ScrollToTop>
  );
}

export default MpsAutoTopupOverview;
